import { Navigate, Outlet } from 'react-router-dom'
import { usePartner } from '../lib/usePartner'
import { RouteLoader } from './RouteLoader'

export function RequirePartner() {
  const { data, isLoading } = usePartner(true)
  if (isLoading) return <RouteLoader />
  if (!data || data.state === 'none') return <Navigate to="/onboarding" replace />
  return <Outlet />
}
